import { Injectable } from "@angular/core";
import * as LDClient from "launchdarkly-js-client-sdk";
import { environment } from "../environments/environment";

@Injectable()
export class LaunchDarklyService {
  private ldClient: LDClient.LDClient;

  constructor() {
    this.ldClient = LDClient.initialize(environment.LD_CLIENT_ID, {
      key: "initial",
      anonymous: true,
    });
  }

  getLDClient(): LDClient.LDClient {
    return this.ldClient;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/launchdarkly.service.ts